var map = {
	"./401_image.svg": 769,
	"./404_error.svg": 24078,
	"./Delete_order.svg": 69427,
	"./India.svg": 43206,
	"./Loading.svg": 14808,
	"./Nepal.svg": 40242,
	"./UAE.svg": 89301,
	"./Vietnam.svg": 8702,
	"./Wall_Clock.svg": 4965,
	"./accordion_arrow.svg": 2408,
	"./action_icon.svg": 43497,
	"./add_charger.svg": 9142,
	"./add_comment.svg": 89643,
	"./add_icon_n.svg": 52428,
	"./add_payment.svg": 23400,
	"./arrow_down_icon.svg": 39089,
	"./arrow_north_east.svg": 35701,
	"./arrow_sort_up.svg": 6700,
	"./attach.svg": 80965,
	"./back.svg": 74347,
	"./back_page.svg": 40833,
	"./bell_filled.svg": 89197,
	"./bell_uncolored.svg": 70306,
	"./black_arrow.svg": 18141,
	"./blocked_icon.svg": 5074,
	"./blue_info_icon.svg": 6607,
	"./box-arrow-up-right.svg": 88198,
	"./calendar.svg": 16762,
	"./calendar_down_arrow.svg": 72844,
	"./calendar_icon.svg": 70964,
	"./calendar_icon_small.svg": 51998,
	"./cancel_icon.svg": 77194,
	"./charger.svg": 4355,
	"./charger_details.svg": 50017,
	"./charger_icon.svg": 76459,
	"./charger_placeholder.svg": 86868,
	"./chat.svg": 94416,
	"./checked_radio.svg": 76049,
	"./checkmark.svg": 15280,
	"./circle_cross.svg": 40032,
	"./circle_tick.svg": 26038,
	"./circular_delete_icon.svg": 63338,
	"./clear.svg": 54666,
	"./clear_all_icon.svg": 90192,
	"./clock_arr.svg": 9238,
	"./clock_arr_new.svg": 87537,
	"./close_circle_filled.svg": 42977,
	"./close_icon.svg": 66644,
	"./close_icon_new.svg": 17785,
	"./comment_edit.svg": 58820,
	"./comment_new.svg": 37634,
	"./comments_icon.svg": 69466,
	"./completed.svg": 40183,
	"./connector_status_icon.svg": 34108,
	"./copy_image.svg": 5558,
	"./copy_light.svg": 28966,
	"./crystalina-logo-mono.svg": 24376,
	"./crystalina-logo.svg": 46833,
	"./cursor.svg": 68105,
	"./delete-ticket.svg": 17316,
	"./delete_icon.svg": 26210,
	"./delete_inner_icon.svg": 28250,
	"./delete_new.svg": 52575,
	"./delete_red.svg": 58752,
	"./delete_red_alert.svg": 56218,
	"./delete_red_icon.svg": 19217,
	"./deselect_icon.svg": 51715,
	"./details_download.svg": 5792,
	"./downArrow.svg": 2231,
	"./downArrowBlack.svg": 42915,
	"./downArrowWhite.svg": 6315,
	"./downArrow_new.svg": 15535,
	"./down_arrow.svg": 40421,
	"./down_arrow_new.svg": 73471,
	"./down_org_arrow.svg": 11819,
	"./download.svg": 23694,
	"./download_arrow.svg": 44536,
	"./download_button_outline.svg": 17305,
	"./download_icon.svg": 53598,
	"./download_icon_inherit.svg": 76495,
	"./drag-icon.svg": 35252,
	"./drag_drop.svg": 77518,
	"./drag_parent_color.svg": 24866,
	"./dropdown.svg": 82143,
	"./dropdown_icon.svg": 3143,
	"./dropped.svg": 85033,
	"./edit-form.svg": 44459,
	"./edit.svg": 76937,
	"./edit_box.svg": 18940,
	"./edit_image.svg": 89125,
	"./edit_inner_icon.svg": 43259,
	"./edit_loading.svg": 18771,
	"./edit_mobile.svg": 18270,
	"./edit_new.svg": 56220,
	"./edit_profile_icon.svg": 18727,
	"./edit_progress.svg": 10175,
	"./editicon.svg": 83062,
	"./error_icon.svg": 60206,
	"./error_mark.svg": 47574,
	"./excel_svg.svg": 38586,
	"./fallback_illustration.svg": 12441,
	"./female_user_icon.svg": 24582,
	"./file_icon.svg": 18461,
	"./file_loader.svg": 53297,
	"./file_preview_icon.svg": 2909,
	"./file_preview_icon_inactive.svg": 21673,
	"./file_upload_icon.svg": 60990,
	"./filter_icon.svg": 64040,
	"./filter_icon_orange.svg": 9059,
	"./first_page_icon.svg": 79483,
	"./flag.svg": 57044,
	"./green_check.svg": 9074,
	"./high_priority_icon.svg": 24699,
	"./history_icon.svg": 84988,
	"./ic_round-upload.svg": 50404,
	"./ideal_ticket.svg": 10099,
	"./image_uploaded_svg.svg": 6610,
	"./in_progress.svg": 79289,
	"./info_icon.svg": 21387,
	"./info_icon_gray.svg": 25061,
	"./info_outline.svg": 35170,
	"./informat_icon.svg": 50151,
	"./information_icon.svg": 17147,
	"./items_icon.svg": 11455,
	"./kebab_menu.svg": 95085,
	"./last_page_icon.svg": 13216,
	"./linked_icon.svg": 25573,
	"./login_bg.svg": 78236,
	"./login_image.svg": 16039,
	"./logout_black_icon.svg": 32,
	"./logout_icon.svg": 43001,
	"./menu_down_arrow.svg": 34449,
	"./next_arrow.svg": 491,
	"./next_page_icon.svg": 52117,
	"./no_comments.svg": 89720,
	"./no_comments_bg.svg": 88617,
	"./no_data.svg": 61207,
	"./no_doc.svg": 45264,
	"./no_image_svg.svg": 98383,
	"./no_notification_bg.svg": 9780,
	"./not_allowed.svg": 10000,
	"./notification_bell.svg": 62293,
	"./on_hold_icon.svg": 38194,
	"./open.svg": 62911,
	"./open_sidemenu.svg": 54376,
	"./orange_arrow.svg": 49621,
	"./orange_next.svg": 61093,
	"./orange_preview.svg": 45350,
	"./payment_down_arrow.svg": 91811,
	"./payment_upward_arrow.svg": 85010,
	"./pdf_icon.svg": 70283,
	"./pdf_svg.svg": 88986,
	"./pin_icon.svg": 85776,
	"./plus.svg": 20675,
	"./plus_outlined.svg": 66429,
	"./previous_page_icon.svg": 13803,
	"./primary_icon.svg": 59827,
	"./profile.svg": 26130,
	"./project_dropped.svg": 28002,
	"./purchase_order.svg": 77009,
	"./question_circle.svg": 56449,
	"./red_down_icon.svg": 25778,
	"./red_info_icon.svg": 24845,
	"./redirect_current.svg": 89286,
	"./redirection_icon.svg": 13382,
	"./remove.svg": 6523,
	"./remove_payment.svg": 73515,
	"./report_download_icon.svg": 6889,
	"./ri_edit-fill.svg": 5130,
	"./right_arrow.svg": 77764,
	"./search_icon.svg": 41122,
	"./share_icon.svg": 54040,
	"./sidemenu_expand.svg": 16640,
	"./sidemenulogo.svg": 18267,
	"./slack.svg": 34815,
	"./statiq_logo.svg": 16147,
	"./status_arrow.svg": 16982,
	"./success_icon.svg": 26321,
	"./tag.svg": 95300,
	"./tag_pricetag_icon.svg": 58942,
	"./tags_arrow_icon.svg": 98630,
	"./testing_down_arrow.svg": 67042,
	"./truck_icon.svg": 78684,
	"./uae_flag.svg": 65322,
	"./unread_bell.svg": 82227,
	"./up_arrow.svg": 6244,
	"./upload_icon.svg": 43897,
	"./upload_image.svg": 99317,
	"./upload_inner_icon.svg": 30660,
	"./uploaded_file_icon.svg": 57870,
	"./verified.svg": 17013,
	"./verified_check.svg": 59397,
	"./verify.svg": 14924,
	"./vertical_three_dots.svg": 54836,
	"./video_icon.svg": 7840,
	"./view_file_circular.svg": 42736,
	"./wall_clock.svg": 26017,
	"./warning.svg": 64370,
	"./white_alert.svg": 23061,
	"./white_down_arrow.svg": 91175,
	"./x_mark_icon.svg": 49980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;